import eventManager from 'helpers/eventManager';

const notify = {
  error(content, options) {
    eventManager.emit('notification-show', content, options);
  },
};

export default notify;




// WEBPACK FOOTER //
// ./src/components/Notify/notify.js